<div class="pdf-page app-aul-033-24" id="aul03324">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> ELECTRONIC BIKES AND SCOOTERS EXCLUSION </b>
  </p>
  <p class="font-medium">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    This endorsement modifies insurance provided under the following: <br />
    COMMERCIAL PROPERTY COVERAGE PART
  </p>
  <p class="font-small">
    The following <b>Electronic Bikes And Scooters Exclusion</b> is added to
    this policy:
  </p>
  <p class="font-small"><b>Electronic Bikes and Scooters Exclusion</b></p>
  <p class="font-small">
    It is understood and agreed that this insurance does not apply to any
    occurrence of fire or fire related damages caused by an electronic bike or
    electronic scooter and/or it’s associated charging equipment and/or
    batteries, whether or not attached to the bike or scooter.
  </p>
  <p class="font-small">
    In the event any portion of this exclusion is found to be invalid or
    unenforceable, the remainder shall remain in full force and effect.
  </p>
  <br />
  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged. </b>
  </p>
</div>
